import AppConstants from 'constants/AppConstants';

interface State {
  hasScrolledDown: boolean;
  hasScrolledUp: boolean;
}

const initialState: State = {
  hasScrolledDown: false,
  hasScrolledUp: false,
};

export default function reducer(state: State = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.SCROLL_SET: {
      return {
        ...state,
        ...payload,
      };
    }
    default:
      return state;
  }
}
